module.exports = __webpack_public_path__ + "img/the-air-filter-company.23b515f9.svg";